"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Tabs;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _reactUseIdHook = require("react-use-id-hook");
require("./Tabs.css");
function Tabs(_ref) {
  var tabs = _ref.tabs,
    panels = _ref.panels,
    onChange = _ref.onChange;
  var id = (0, _reactUseIdHook.useId)();
  var _React$useState = _react.default.useState(0),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    active = _React$useState2[0],
    setActive = _React$useState2[1];
  var _React$useState3 = _react.default.useState(-1),
    _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
    focused = _React$useState4[0],
    setFocused = _React$useState4[1];
  _react.default.useEffect(function () {
    if (onChange && focused !== -1) {
      onChange(id, active);
    }
  }, [active]);
  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'ArrowLeft') {
      setActive(active === 0 ? tabs.length - 1 : active - 1);
    } else if (e.key === 'ArrowRight') {
      setActive(active === tabs.length - 1 ? 0 : active + 1);
    } else if (e.key === 'Home') {
      setActive(0);
    } else if (e.key === 'End') {
      setActive(tabs.length - 1);
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-tabs"
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: "tablist",
    className: "tablist",
    onKeyDown: handleKeyDown
  }, tabs.map(function (v, i) {
    return /*#__PURE__*/_react.default.createElement("button", {
      className: "custom-tab".concat(i === active ? " active" : ""),
      id: "tab-".concat(id, "-").concat(i),
      type: "button",
      role: "tab",
      tabIndex: i === active ? "" : "-1",
      "aria-selected": i === active,
      "aria-controls": "tabpanel-".concat(id, "-").concat(i),
      onBlur: function onBlur() {
        setFocused(-1);
      },
      onFocus: function onFocus() {
        setFocused(i);
      },
      onClick: function onClick() {
        setActive(i);
        setFocused(i);
      }
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "buttontext"
    }, v));
  })), panels.map(function (v, i) {
    return /*#__PURE__*/_react.default.createElement("div", {
      id: "tabpanel-".concat(id, "-").concat(i),
      role: "tabpanel",
      "aria-labelledby": "tab-".concat(id, "-").concat(i),
      className: i === active ? "" : "d-none",
      tabIndex: "0"
    }, v);
  }));
}